import React from "react";
import Datapin from "../../Component/Products/data-pin";

const MainDataPin = () => {
	return <Datapin />;
};

export default MainDataPin;
